import React, { useEffect, Suspense } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import Loading from "@/components/Loading";
import { getAuthToken } from "@/utils/authStorage";

const AuthLayout = () => {
  const navigate = useNavigate();
  const { isAuth, user } = useSelector((state) => state.auth);
  const token = getAuthToken();

  useEffect(() => {
    if (isAuth && user && token) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuth, user, token, navigate]);

  return (
    <>
      <Suspense fallback={<Loading />}>
        <ToastContainer />
        <Outlet />
      </Suspense>
    </>
  );
};

export default AuthLayout;
